export const CF_ASSET_PATH = "file.url";
